export const SPLINE_SCENE_URL_HOME_MAIN =
  'https://prod.spline.design/zISgzVk0GIo10ob3/scene.splinecode';

export const SPLINE_SCENE_URL_HOME_MAIN_DARK =
  'https://prod.spline.design/G0jchqY5N79jKsER/scene.splinecode';
